import styled from 'styled-components';
import colours from 'theme/atoms/colours';

export const NavigationContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  margin-top: 50px;
`;

export const DotsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

interface DotProps {
  active: boolean;
}

export const Dot = styled.div<DotProps>`
  width: 10px;
  height: 10px;
  background-color: ${(props) =>
    props.active ? colours.neutral[700] : 'white'};
  border: 1px solid ${colours.neutral[700]};
  border-radius: 50%;
`;

export const NextButtonContainer = styled.div`
  position: absolute;
  right: 20px;
`;

export const BackButtonContainer = styled.div`
  position: absolute;
  left: 20px;
`;
